import React, {useEffect, useState} from 'react';
import {Button, Modal, Select} from "antd";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";
import ModalOfficeHierarchy from "./ModalOfficeHierarchy";
import MyMapComponent from "./MyMapComponent";

const CreateBranchModal    = (props) => {
    const [sendData, setSendData] = useState({
        hierarchy: props?.level,
        branch_title: '',
        // building_id: '',
        latitude: '',
        longitude: '',
    })

    const [latitude, setlatitude] = useState("")
    const [longitude, setlongitude] = useState("")

    const [isModalOffice, setIsModalOffice] = useState(false);
    const [offices, setOffices] = useState([])

    const getBuilding = () => {
        axios.get(API_PATH +"company/" + localStorage.getItem("id") + "/building/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const sendAll = () => {
        if (props?.type){
            axios.put(API_PATH + "company/" + localStorage.getItem("id") + "/branch/" + props?.selectData?.id, {...sendData, latitude: latitude, longitude: longitude}, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((res =>{
                    props.setIsModal(false)
                    setSendData({
                        hierarchy: 1,
                        branch_title: '',
                        // building_id: '',
                    })
                    setlatitude("")
                    setlongitude("")
                    props?.getAllData()
                }))
        } else {
            axios.post(API_PATH + "company/" + localStorage.getItem("id") + "/branch/", {...sendData, latitude: latitude, longitude: longitude, parent_id: props?.parent_id ? props?.parent_id : null}, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((res =>{
                    props.setIsModal(false)
                    setSendData({
                        hierarchy: 1,
                        branch_title: '',
                        // building_id: '',
                    })
                    setlatitude("")
                    setlongitude("")
                    props?.getAllData()
                }))

        }
    }
    useEffect(() => {
        getBuilding()
        if (props?.parent_id){
            setSendData({
                ...sendData,
                parent_id: props?.parent_id
            })
        }
        if(props?.selectData?.branch_title?.length > 0){

            setSendData({...sendData,
                branch_title: props?.selectData.branch_title,
                // building_id: props?.selectData?.building_id
            })
            setlatitude(props?.selectData?.latitude)
            setlongitude(props?.selectData?.longitude)
        } else {
            // console.log("NO SELECTED")
        }
    }, []);
    return (
        <>
            <Modal title={props?.title}
                   open={props.isModal}
                   onCancel={() => props.setIsModal(false)}
                   footer={[
                       <Button key="submit" type="primary" onClick={sendAll}>
                           Добавить
                       </Button>,
                       <Button key="submit" type="default" onClick={() => props.setIsModal(false)}>
                           Отменить
                       </Button>
                   ]}
            >
                <div className="cam-add-modal">
                    <div className="inputs-box">
                        <label className="font-family-medium">Название </label>
                        <input
                            onChange={(e) => setSendData({...sendData, branch_title: e.target.value})}
                            value={sendData?.branch_title}
                            type="text"/>
                    </div>
                    {/*<div className="inputs-box">*/}
                    {/*    <label className="font-family-medium">Филиал</label>*/}
                    {/*    <div className="add-btn-modal">*/}
                    {/*     <div className="d-flex w-100">*/}
                    {/*         <Select*/}
                    {/*             showSearch*/}
                    {/*             placeholder="Поиск, чтобы выбрать"*/}
                    {/*             optionFilterProp="children"*/}
                    {/*             className="w-100"*/}
                    {/*             onSearch={getBuilding}*/}
                    {/*             value={sendData?.building_id}*/}
                    {/*             onChange={(e) => setSendData({...sendData, building_id: e})}*/}
                    {/*             filterOption={(input, option) => (option?.label ?? '').includes(input)}*/}
                    {/*             filterSort={(optionA, optionB) =>*/}
                    {/*                 (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())*/}
                    {/*             }*/}
                    {/*             options={offices?.map((item) => {*/}
                    {/*                 return {*/}
                    {/*                     value: item.id,*/}
                    {/*                     label:*/}
                    {/*                     item?.name*/}
                    {/*                 };*/}
                    {/*             })}*/}
                    {/*         />*/}
                    {/*         <button*/}
                    {/*             className="font-family-medium add-btn-plus ml-8"*/}
                    {/*             onClick={() => setIsModalOffice(true)}>*/}
                    {/*             <img src="/icon/plus.svg" alt="+"/>*/}
                    {/*         </button>*/}
                    {/*     </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <MyMapComponent
                        sendData={sendData}
                        setSendData={setSendData}
                        setlongitude={setlongitude}
                        setlatitude={setlatitude}
                        longitude={longitude}
                        latitude={latitude}
                        selectpls={props?.selectData?.id}
                    />
                </div>
            </Modal>
            {
                isModalOffice
                ?
                    <ModalOfficeHierarchy
                        isModalOffice={isModalOffice}
                        setIsModalOffice={setIsModalOffice}
                        getBuilding={getBuilding}

                    />
                    :
                    ""
            }

        </>
    );
};

export default CreateBranchModal;